export function omitEmpty<T extends Record<string, unknown>>(
  obj?: T,
): Partial<T> {
  if (obj == null) return {};
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([, v]) => v !== '' && v !== undefined && v !== null,
    ),
  ) as Partial<T>;
}
